module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/99.187e8107.png";